export default __webpack_public_path__ + "side-bar.jpg";